var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:{borderWithoutBg: _vm.borderWithoutBg, yellow: _vm.yellow, big: _vm.big, small: _vm.small}},'button',_vm.$props,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }